import React, { forwardRef } from 'react';
const Select = forwardRef(function Select({ children, testId = 'store-select', ...otherProps }, ref) {
    return (React.createElement("select", Object.assign({ ref: ref, "data-store-select": true, "data-testid": testId }, otherProps), children));
});
export default Select;
//# sourceMappingURL=Select.js.map